<template>
    <m-main-layout>
        <div class="page-content-main">
            <el-form
                :model="formData"
                status-icon
                :rules="rules"
                ref="form"
                label-width="auto"
                class="margin-top"
                style="width:800px;"
            >
                <el-form-item label="开启测试支付" prop="test_pay">
                    <el-switch
                        v-model="formData.test_pay"
                        active-color="#13ce66"
                        active-value="1"
                        inactive-value="0"
                        active-text="开启"
                        inactive-text="关闭"
                    >
                    </el-switch>
                </el-form-item>
                <el-form-item label="微信支付商户号" prop="weixin_mch_id">
                    <el-input v-model="formData.weixin_mch_id" style="width:300px;">
                    </el-input>
                </el-form-item>
                <el-form-item label="微信支付商户秘钥" prop="weixin_mch_secret">
                    <el-input v-model="formData.weixin_mch_secret" style="width:300px;">
                    </el-input>
                </el-form-item>
                <el-form-item label="支付回调地址" prop="weixin_notify_url">
                    <el-input v-model="formData.weixin_notify_url" style="width:300px;"></el-input>
                </el-form-item>
	            <el-form-item label="标讯支付文字描述" prop="pay_btn_text">
		            <el-input v-model="formData.pay_btn_text" style="width:300px;">
		            </el-input>提示：{price}为金额占位符
	            </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "add",
    data() {
        return {
            formData: {
                test_pay:'0',
                weixin_mch_id: "",
                weixin_mch_secret: "",
                pay_btn_text:'',
	            weixin_notify_url:''
            },
            rules: {
                test_pay: [{required: true}],
                weixin_mch_id: [{required: true}],
                weixin_mch_secret: [{required: true}],
                pay_btn_text: [{required: true}],
	            weixin_notify_url: [{required: true}],
            }
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        submitForm(formName) {
            let _this = this;
            console.log(_this.formData);
            this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.$http.httpPost({
                        url: "/SystemSetting/edit",
                        datas: {..._this.formData},
                        success: res => {
                            if (res === "ok") {
                                _this.$message.success("修改成功");
                            } else {
                                _this.$message.error("修改失败");
                            }
                            // _this.$message.info(res.msg);
                            // _this.$router.replace({path: '/cate/list'})
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getDetail() {
            let _this = this;

            let _skeys = [];

            for (let k in this.formData) {
                _skeys.push(k);
            }

            _this.$http.httpPost({
                url: "/SystemSetting/getSystem",
                datas: {skey: _skeys},
                success: res => {
                    _this.formData = res;
                    _this.formData.test_pay = res.test_pay.toString();
                }
            });
        }
    }
};
</script>
